import * as Sentry from '@sentry/react';
import { MutableRefObject, useEffect, useRef } from 'react';

import mixpanel from 'mixpanel-browser';

import API from '@api/API';

import { useIsVisible } from '@hooks/useIsVisible';

export const sendEntertainerDetailsPageView = async (
  entertainerId: string,
  type: 'profile' | 'impression' = 'profile',
) => {
  try {
    const urlParams = new URLSearchParams(window.location.search);
    const fbclid = urlParams.get('fbclid') || '';
    const clientUserAgent = window.navigator.userAgent ?? '';
    const deviceId = (mixpanel as any)?.cookie?.props?.$device_id;

    if (deviceId && process.env.REACT_APP_ENV !== 'dev') {
      await API.post(`/v1/entertainers/${entertainerId}/view`, {
        entertainerId,
        deviceId,
        fbclid,
        clientUserAgent,
        type,
      });
    }
  } catch (e) {
    Sentry.captureException(e);
  }
};

export const useEntertainerImpression = (
  entertainerId: string,
  ref: MutableRefObject<HTMLElement>,
) => {
  const didSendRef = useRef(false);
  const { isVisible } = useIsVisible(ref);

  useEffect(() => {
    if (isVisible && !didSendRef.current) {
      didSendRef.current = true;
      sendEntertainerDetailsPageView(entertainerId, 'impression');
    }
  }, [isVisible]);
};
